import React, { useEffect } from 'react';

import { HStack, Stack, Text } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { Controller, useFieldArray } from 'react-hook-form';

import { Icon, Select } from 'components';
import { debounceBatch } from 'utils/debounces';

export default function BatchesForm({
  control, name, setValue, watch,
}) {
  const {
    fields, remove, append,
  } = useFieldArray({
    name,
    control,
    keyName: 'key',
  });

  const inputs = watch(name);

  useEffect(() => {
    if (isEmpty(fields)) {
      if (!isEmpty(inputs)) {
        append(inputs);
      } else {
        append({});
      }
    }
  },
  [fields, inputs]);

  return (
    <>
      <Stack spacing={2}>
        {fields?.map((_, index) => (
          <HStack>
            <Controller
              key={`${name}.${index}`}
              control={control}
              name={`${name}.${index}`}
              render={({ field }) => (
                <Select
                  w="60%"
                  label="Carga a ser entregue (opcional)"
                  loadOptions={debounceBatch}
                  {...field}
                />
              )}
            />
            <Icon
              cursor="pointer"
              onClick={() => {
                if (index) {
                  remove(index);
                } else {
                  setValue(`${name}.0`, { });
                }
              }}
              position="relative"
              top={2}
              color="gray.500"
              name="trash"
            />
          </HStack>
        ))}
      </Stack>
      <Text
        cursor="pointer"
        mt={6}
        py={2}
        color="primary.700"
        onClick={() => append({ id: 'null', label: null })}
        variant="largeBold">
        + Adicionar Carga
      </Text>
    </>
  );
}
